import Vue from 'vue'
import VueRouter from 'vue-router'
import RegisterForm from "./js/views/register/Form"
import RegisterFundraiserForm from './js/views/register-organizer/Form'
import UpgradeForm from "./js/views/upgrade/Form"
import Account from "./js/views/profile/Account"
import PayoutInformation from "./js/views/profile/PayoutInformationView"
import PersonalInformation from "./js/views/profile/PersonalInformationView"
import PaymentInformation from "./js/views/profile/PaymentInformationView"
import ContactInformation from "./js/views/profile/ContactInformationView"
import ChangePassword from "./js/views/profile/ChangePasswordView"
import DonationView from "./js/views/campaign/DonationView"
import CreateCampaign from "./js/views/campaign/CreateCampaignView"
import EditCampaign from "./js/views/campaign/EditCampaignView"
import PageNotFound from "./js/views/errors/PageNotFound"
import store from './js/store'
import { scrollTop } from './js/utils/componentHelper'

Vue.use(VueRouter)

const notRegistered = (to, from, next) => {
    const processUserData = () => {
        if (store.getters.authUser.registered !== true) {
            if (!store.getters.authUser.verified && store.getters.authUser.authenticated) {
                window.location = '/email/verify'
                return false
            } else {
                return next()
            }
        } else {
            return next('/profile')
        }
    }

		scrollTop()
    return store.dispatch('updateAuthUser').then( () => {
        if (store.getters.authUser.expired !== false) {
            return store.dispatch('fetchAuthUser').then( () => {
                return processUserData()
            })
        }
        return processUserData()
    })
}

const guestConditions = (to, from, next) => {
	const processUserData = () => {
		if (store.getters.authUser.authenticated !== true) {
			return next()
		} else {
			return next('/notfound')
		}
	}

	scrollTop()
	return store.dispatch('updateAuthUser').then( () => {
		if (store.getters.authUser.expired !== false) {
			return store.dispatch('fetchAuthUser').then( () => {
				return processUserData()
			})
		}
		return processUserData()
	})
}

const authConditions = (to, from, next, callback) => {
	const processUserData = () => {
		if (store.getters.authUser.authenticated
			&& store.getters.authUser.registered
			&& store.getters.authUser.verified) {
			if (typeof callback === "function" && !callback(store.getters.authUser)) {
				return next('/notfound')
			}

			return next()

		} else if (store.getters.authUser.authenticated) {
			if (!store.getters.authUser.verified) {
				window.location = '/email/verify'
				return false
			} else {
				return next('/register/form')
			}
		} else {
			window.location = '/login'
			return false
		}
	}



	scrollTop()
	return store.dispatch('updateAuthUser').then(() => {
		if (store.getters.authUser.expired !== false) {
			return store.dispatch('fetchAuthUser').then(() => {
				return processUserData()
			})
		}
		return processUserData()
	})
}

const registeredConditions = (to, from, next, callback) => {
	const processUserData = () => {
		if (store.getters.authUser.authenticated
			&& store.getters.authUser.verified) {
			if (typeof callback === "function" && !callback(store.getters.authUser)) {
				return next('/notfound')
			}

			return next()

		} else if (store.getters.authUser.authenticated) {
			if (!store.getters.authUser.verified) {
				window.location = '/email/verify'
				return false
			} 
		} else {
			window.location = '/login'
			return false
		}
	}



	scrollTop()
	return store.dispatch('updateAuthUser').then(() => {
		if (store.getters.authUser.expired !== false) {
			return store.dispatch('fetchAuthUser').then(() => {
				return processUserData()
			})
		}
		return processUserData()
	})
}

const organizerConditions = (to, from, next, callback) => {
	return authConditions(to, from, next, (user) => {
		return user.roles && user.roles.includes('organizer');
	})
}

const organizerRegisteredConditions = (to, from, next, callback) => {
	return registeredConditions(to, from, next, (user) => {
		return user.roles && user.roles.includes('organizer');
	})
}


export default new VueRouter({
	mode: 'history',
	routes: [
		{
			path: '/profile', name: 'profile', component: Account,
			meta: {title: 'Account'},
			beforeEnter: authConditions,
		},
		{
			path: '/profile/payout-information', name: 'payoutInformation', component: PayoutInformation,
			meta: {title: 'Bank Information'},
			beforeEnter: organizerConditions,
		},
		{
			path: '/profile/personal-information', name: 'personalInformation', component: PersonalInformation,
			meta: {title: 'Personal Information'},
			beforeEnter: authConditions,
		},
		{
			path: '/profile/payment-information', name: 'paymentInformation', component: PaymentInformation,
			meta: {title: 'Payment Information'},
			beforeEnter: authConditions,
		},
		{
			path: '/profile/contact-information', name: 'contactInformation', component: ContactInformation,
			meta: {title: 'Contact Information'},
			beforeEnter: authConditions,
		},
		{
			path: '/profile/change-password', name: 'changePassword', component: ChangePassword,
			meta: {title: 'Change Password'},
			beforeEnter: authConditions,
		},
		{
			path: '/upgrade-account/form', name: 'upgrade', component: UpgradeForm,
			meta: {title: 'Account Upgrade'},
			beforeEnter: authConditions,
		},
		{
			path: '/register/form', name: 'register', component: RegisterForm,
			meta: {title: 'Register'},
			beforeEnter: notRegistered,
		},
		{
			path: '/campaign/create/:slug?', name: 'createCampaign', component: CreateCampaign,
			meta: {title: 'Create Campaign'},
			beforeEnter: organizerRegisteredConditions,
		},
		{
			path: '/campaign/edit/:slug', name: 'editCampaign', component: EditCampaign,
			meta: { title: 'Edit Campaign' },
			beforeEnter: organizerConditions,
		},
		{
			path: '/campaign/:slug/donate', name: 'donationView', component: DonationView,
			meta: { title: 'Donation'},
		},
		{
			path: '*', name: '404', component: PageNotFound,
			meta: {title: 'Page Not Found'}
		},
		{
			path: '/register-fundraiser/form', name: 'registerFundraiser', component: RegisterFundraiserForm,
			meta: {title: 'Register Fundraiser'},
			beforeEnter: notRegistered,
		},
	]
})
